import { render, staticRenderFns } from "./self.vue?vue&type=template&id=1224417e&scoped=true"
import script from "./self.vue?vue&type=script&lang=js"
export * from "./self.vue?vue&type=script&lang=js"
import style0 from "./self.vue?vue&type=style&index=0&id=1224417e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224417e",
  null
  
)

export default component.exports